import React from 'react'
import styled from 'styled-components'
import Modal from 'styled-react-modal'

const StyledModal = Modal.styled({
  backgroundColor: 'white',
  padding: '30px',
  width: '75%',
  '@media (min-width: 576px)': {
    width: '400px',
  },
})

const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  text-align: center;
  margin-bottom: 0;
`

const StyledEmail = styled.a`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
  white-space: nowrap;
`

interface DispensaryOptOutModalProps {
  optedOutOfDispensary: boolean | null | undefined
  isOpen: boolean
  toggleModal: () => void
}

const DispensaryOptOutModal: React.FC<DispensaryOptOutModalProps> = ({
  optedOutOfDispensary,
  isOpen,
  toggleModal,
}) => {
  return (
    <StyledModal isOpen={isOpen} onBackgroundClick={toggleModal} onEscapeKeydown={toggleModal}>
      {optedOutOfDispensary ? (
        <StyledParagraph>
          Your Virtual Dispensary has been disabled. Contact us at{' '}
          <StyledEmail href="mailto:support@designsforhealth.com" target="_blank" rel="noreferrer">
            support@designsforhealth.com
          </StyledEmail>{' '}
          to request to re-enable access to Virtual Dispensary data and commissions.
        </StyledParagraph>
      ) : (
        <StyledParagraph>
          Practitioners that are not legally allowed to earn commissions or view sales data of
          potential patients may request to disable access to Virtual Dispensary data and
          commissions by contacting us at{' '}
          <StyledEmail href="mailto:support@designsforhealth.com" target="_blank" rel="noreferrer">
            support@designsforhealth.com
          </StyledEmail>
        </StyledParagraph>
      )}
    </StyledModal>
  )
}

export default DispensaryOptOutModal
